import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "green-reset",
  "use": "green-reset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"green-reset\"><path d=\"M594.047 9.801v51.584a459.616 459.616 0 1 1-164.296 0V9.801a510.426 510.426 0 1 0 164.296 0z\" fill=\"#00ffbf\" /><path d=\"M478.756 0h64.48v459.874h-64.48z\" fill=\"#00ffbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol